import { useAuth } from "../context/AuthContext.jsx";

/* Wrap a page that needs a capability. Mirrors the vanilla pages' client-side
 * cap check: render the page when allowed, else a friendly "ask an admin" notice
 * (matching how /docs etc. behave when the cap is missing). */
export default function RequireCap({ cap, children }) {
  const { hasCap } = useAuth();
  if (hasCap(cap)) return children;
  return (
    <main className="page">
      <div className="notice">
        <b>No access.</b> You don't have the <code>{cap}</code> permission. Ask an
        admin to grant it.
      </div>
    </main>
  );
}
